<template>
	<div>
		<div
			class="text-block__highlight"
			data-anchor="text-block__highlight"
			:style="`height: ${selectionData.height}px;
				width: ${selectionData.width}px;
				top: ${selectionData.y}px;
				left: ${selectionData.x}px;`"
		>
			<helio-tooltip
				:active="selection !== ''"
				class="text-block__tooltip"
				anchor="text-block__highlight"
				position="right"
			>
				<template v-slot:content>
					<post-tooltip :text="selection" />
				</template>
			</helio-tooltip>
		</div>
		<div
			class="text-block"
			@mouseup="getHightlightedText"
		>
			<client-only-wrapper>
				<div
					v-if="nextImage"
					:class="`text-block__image--${next.content.alignment}`"
				>
					<div class="text-block__image">
						<post-pinterest @click="sharePinterest" />

						<!-- eslint-disable-next-line -->
						<img
							:src="next.content.media.url"
							:alt="next.content.caption"
						/>
					</div>
					<caption
						v-if="next.content.caption"
						class="text-block__caption"
					>
						<a
							v-if="next.content.caption_link"
							target="_blank"
							:href="next.content.caption_link"
						>
							{{ next.content.caption }}
						</a>
						<template v-else>
							{{ next.content.caption }}
						</template>
					</caption>
				</div>
			</client-only-wrapper>
			<!-- eslint-disable-next-line -->
			<div v-html="block.content.text" />
		</div>
	</div>
</template>

<script>
import Tooltip from '../../../tooltip/Tooltip.vue';
import ClientOnlyWrapper from '../../../client-only-wrapper/ClientOnlyWrapper.vue';
import PostPinterest from '../../post-pinterest/PostPinterest.vue';
import PostTooltip from '../../post-tooltip/PostTooltip.vue';

export default {
	components: {
		'helio-tooltip': Tooltip,
		'post-pinterest': PostPinterest,
		'post-tooltip': PostTooltip,
		ClientOnlyWrapper,
	},
	props: {
		block: {
			type: Object,
			required: true,
		},
		next: {
			type: Object,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			selection: '',
			selectionData: {
				x: 0,
				y: 0,
				height: 0,
				width: 0,
			},
		};
	},
	computed: {
		nextImage() {
			return (
				this.next
				&& this.formatBlockType(this.next.content_type) === 'ImageBlock'
				&& (this.next.content.alignment === 'left-align'
				|| this.next.content.alignment === 'oversize-left')
			);
		},
	},
	mounted() {
		window.addEventListener('click', this.clearSelection, true, false);
	},
	beforeDestroy() {
		window.removeEventListener('click', this.clearSelection, true, false);
	},
	methods: {
		getHightlightedText() {
			if (typeof window !== 'undefined') {
				const selection = window.getSelection();
				this.selection = selection.toString();

				if (this.selection !== '') {
					window.addEventListener('scroll', this.getHightlightedText);
					this.positionBox(selection);
					document.execCommand('copy');
				} else {
					window.removeEventListener('scroll', this.getHightlightedText);
					this.selectionData.height = 0;
					this.selectionData.width = 0;
				}
			}
		},
		positionBox(selection) {
			const highlight = selection.getRangeAt(0)
				.getBoundingClientRect();

			this.selectionData.x = highlight.left;
			this.selectionData.y = highlight.top;
			this.selectionData.height = highlight.height;
			this.selectionData.width = highlight.width;
		},
		clearSelection(event) {
			const { target } = event;
			if (!target.closest('.text-block')) {
				this.selection = '';
				this.selectionData.height = 0;
				this.selectionData.width = 0;
			}
		},
		sharePinterest() {
			this.$parent.$emit('imageClick');
		},
	},
};
</script>

<style lang="scss" src="./text-block.scss" />
